<template>
  <div>
    <v-card>
      <v-toolbar card color="white">
        <v-text-field
          flat
          solo
          hide-details
          prepend-icon="search"
          placeholder="Tìm trên danh sách người dùng"
          v-model="table.searchText"
        ></v-text-field>
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="addUserForm.isShowDialog = true">
            <v-icon>add</v-icon>
          </v-btn>
          <span>Thêm mới người dùng</span>
        </v-tooltip>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-data-table
          item-key="id"
          :headers="table.headers"
          :search="table.searchText"
          :items="datasource"
          :rows-per-page-items="[10, 20, 50, 100]"
          :loading="isLoading"
        >
          <template slot="items" slot-scope="props">
            <tr @contextmenu.prevent="openContextMenu($event, props.item)">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.phone }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.address }}</td>
              <td>
                {{
                  new Date(props.item.createdDate).toISOString().slice(0, 10)
                }}
              </td>
              <td>
                {{
                  new Date(props.item.modifiedDate).toISOString().slice(0, 10)
                }}
              </td>
              <td>
                <div class="text-xs-center">
                  <v-menu offset-y>
                    <v-btn icon flat slot="activator" color="primary">
                      <v-icon>expand_more</v-icon>
                    </v-btn>
                    <v-list>
                      <v-list-tile
                        v-for="(item, index) in menu"
                        :key="index"
                        @click="item.click(props.item)"
                        :disabled="!item.isAccess"
                      >
                        <v-list-tile-title>
                          <v-icon class="menu-item-icon">{{
                            item.icon
                          }}</v-icon>
                          <span>{{ item.title }}</span>
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-layout row justify-center>
      <v-dialog v-model="resetPasswordDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Đặt lại mật khẩu?</v-card-title>
          <v-card-text v-if="selectedUser"
            >Mật khẩu của {{ selectedUser.name }} sẽ được thiết lập về giá trị
            mặc định là 123456789</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="resetPasswordDialog = false"
              >Từ chối</v-btn
            >
            <v-btn
              color="primary"
              flat
              @click.native="resetPasswordSubmit()"
              :loading="resetPasswordLoading"
              >Đồng ý</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- Dialog -->
    <div class="text-xs-center">
      <v-dialog v-model="addUserForm.isShowDialog" width="480">
        <v-card>
          <v-card-title class="headline">Tạo người dùng</v-card-title>
          <v-card-text>
            <v-form v-model="addUserForm.isValid" ref="addUserForm">
              <v-text-field
                v-model="addUserForm.fullName"
                :rules="[validate.required]"
                label="Tên người dùng"
              ></v-text-field>
              <v-text-field
                v-model="addUserForm.phone"
                :rules="[validate.required, validate.numeric, validate.min]"
                @change="checkPhoneFromServer()"
                :error-messages="addUserForm.validateString.phone"
                label="Số điện thoại"
                mask="################"
              ></v-text-field>
              <v-text-field
                v-model="addUserForm.email"
                @change="checkEmailFromServer()"
                :error-messages="addUserForm.validateString.email"
                label="Email"
              ></v-text-field>
              <v-text-field
                v-model="addUserForm.password"
                :rules="[validate.required, validate.min]"
                :append-icon="
                  addUserForm.isShowPassword ? `visibility_off` : `visibility`
                "
                :type="addUserForm.isShowPassword ? `text` : `password`"
                @click:append="
                  addUserForm.isShowPassword = !addUserForm.isShowPassword
                "
                label="Mật khẩu"
              ></v-text-field>
              <v-text-field
                v-model="addUserForm.remark"
                label="Ghi chú"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat="flat" @click="addUserForm.isShowDialog = false"
              >Hủy</v-btn
            >
            <v-btn
              color="primary"
              flat="flat"
              :loading="addUserForm.isLoading"
              @click="createUserSubmit()"
              >Tạo người dùng</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- End Dialog -->

    <!-- Role Dialog -->
    <div class="text-xs-center">
      <v-dialog v-model="addRoleForm.isShowDialog" width="800">
        <roles
          v-if="addRoleForm.isShowDialog"
          :user="selectedUser"
          @show="addRoleForm.isShowDialog = $event"
        />
      </v-dialog>
    </div>
    <!-- Role Dialog -->

    <!-- Send Notification Dialog -->
    <div class="text-xs-center">
      <v-dialog v-model="sendNotificationForm.isShowDialog" width="480" persistent>
        <send-notification
          :user="selectedUser"
          @close="sendNotificationForm.isShowDialog = false"
        />
      </v-dialog>
    </div>
    <!-- Context Menu -->
    <vue-context
      ref="contextMenu"
      v-if="loggedUser.isProvider || loggedUser.isDistributor"
    >
      <v-list>
        <v-list-tile
          v-for="(item, index) in menu"
          :key="index"
          @click="item.click()"
          :disabled="!item.isAccess"
        >
          <v-list-tile-title>
            <v-icon class="menu-item-icon">{{ item.icon }}</v-icon>
            <span>{{ item.title }}</span>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </vue-context>
    <!-- Context Menu -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { VueContext } from 'vue-context';
import validate from '@/utils/validate';
import Roles from './Role';
import SendNotification from './SendNotification';
import * as Auth from '@/utils/auth';

export default {
  components: {
    VueContext,
    Roles,
    SendNotification
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    datasource: {
      type: Array,
      default: []
    },
    totalVehicle: {
      type: Number,
      default: -1
    }
  },

  data () {
    return {
      validate: validate,
      table: {
        searchText: '',
        headers: [
          {
            text: 'Tên',
            value: 'name'
          },
          {
            text: 'SĐT',
            value: 'phone'
          },
          {
            text: 'Email',
            value: 'email'
          },
          {
            text: 'Địa chỉ',
            value: 'address'
          },
          {
            text: 'Ngày tạo',
            value: 'createdDate'
          },
          {
            text: 'Lần chỉnh sửa cuối',
            value: 'modifiedDate'
          },
          {
            text: '',
            value: '#'
          }
        ]
      },
      selectedUser: null,
      resetPasswordDialog: false,
      resetPasswordLoading: false,
      addUserForm: {
        isValid: false,
        isShowPassword: false,
        isShowDialog: false,
        isLoading: false,
        accountId: '',
        fullName: '',
        email: '',
        phone: '',
        password: '',
        remark: '',
        validateString: {
          phone: '',
          email: ''
        }
      },
      addRoleForm: {
        isShowDialog: false,
      },
      sendNotificationForm: {
        isShowDialog: false,
      },
      menu: [
        {
          title: 'Truy cập web app V1',
          icon: 'desktop_windows',
          click: item => {
            if (item) this.selectedUser = item;
            this.forceLoginV1Submit();
          },
          isAccess: true
        },
        {
          title: 'Truy cập web app V2',
          icon: 'desktop_windows',
          click: item => {
            if (item) this.selectedUser = item;
            this.forceLoginV2Submit();
          },
          isAccess: true
        },
        {
          title: 'Đặt lại mật khẩu',
          icon: 'cached',
          click: item => {
            if (item) this.selectedUser = item;
            this.resetPasswordDialog = true;
          },
          isAccess: true
        },
        {
          title: `Gửi thông báo (${this.totalVehicle})`,
          icon: 'send',
          click: item => {
            if (item) this.selectedUser = item;
            this.sendNotificationForm.isShowDialog = true;
          },
          isAccess: Auth.checkGroupRoles(['administrator', 'CS']) && this.totalVehicle > 0
        },
        {
          title: 'Phân quyền',
          icon: 'note_add',
          click: item => {
            if (item) this.selectedUser = item;
            this.addRoleForm.isShowDialog = true;
          },
          isAccess: true
        },
      ],
    };
  },

  computed: {
    ...mapGetters(['loggedUser'])
  },

  watch: {
    totalVehicle (newTotalVehicle) {
      this.menu.forEach(item => {
        if (item.icon === 'send') {
          item.title = `Gửi thông báo (${newTotalVehicle} xe)`;
          item.isAccess = Auth.checkGroupRoles(['administrator', 'CS']) && newTotalVehicle > 0;
        }
      });
    }
  },

  created () {
    this.addUserForm.accountId = this.$route.query.accountId;
  },

  methods: {
    ...mapActions([
      'resetPassword',
      'forceLogin',
      'checkPhone',
      'checkEmail',
      'createUser'
    ]),

    openContextMenu (event, item) {
      this.selectedUser = item;
      if (this.loggedUser.isProvider || this.loggedUser.isDistributor) {
        this.$refs.contextMenu.open(event);
      }
    },

    resetPasswordSubmit () {
      this.resetPasswordLoading = true;
      this.resetPassword(this.selectedUser.id)
        .then(success => {
          this.resetPasswordDialog = false;
          this.resetPasswordLoading = false;
          if (success) {
            window.getApp.showMessage('Đổi mật khẩu thành công');
          } else {
            window.getApp.showMessage(
              'Đổi mật khẩu thất bại, vui lòng thử lại',
              'error'
            );
          }
        })
        .catch(_ => {
          this.resetPasswordLoading = false;
          window.getApp.showMessage(
            'Đổi mật khẩu thất bại, vui lòng thử lại',
            'error'
          );
        });
    },

    forceLoginV1Submit () {
      window.getApp.showLoading(true);
      this.forceLogin(this.selectedUser.id)
        .then(res => {
          window.getApp.showLoading(false);
          let url = window.location.href;
          if (url.includes('localhost')) {
            window.open(
              `http://localhost:8888/#/map?accessToken=${
                res.json.access_token
              }&refreshToken=${res.json.refresh_token}`
            );
          } else if (url.includes('dev')) {
            window.open(
              `http://dev.web.motrak.vn/#/map?accessToken=${
                res.json.access_token
              }&refreshToken=${res.json.refresh_token}`
            );
          } else {
            window.open(
              `https://web.motrak.vn/#/map?accessToken=${
                res.json.access_token
              }&refreshToken=${res.json.refresh_token}`
            );
          }
        })
        .catch(_ => {
          window.getApp.showLoading(false);
          window.getApp.showMessage(
            'Truy cập thất bại, vui lòng thử lại',
            'error'
          );
        });
    },

    forceLoginV2Submit () {
      window.getApp.showLoading(true);
      this.forceLogin(this.selectedUser.id)
        .then((res) => {
          window.getApp.showLoading(false);
          let url = window.location.href;
          const accessToken = res.json.access_token;
          const refreshToken = res.json.refresh_token;
          if (url.includes('localhost')) {
            window.open(
              `http://localhost:4200/forceLogin?accessToken=${accessToken}&refreshToken=${refreshToken}`
            );
          } else if (url.includes('dev')) {
            window.open(
              `https://motrak.avema-iot.com/forceLogin?accessToken=${accessToken}&refreshToken=${refreshToken}`
            );
          } else {
            window.open(
              `https://v2.motrak.vn/forceLogin?accessToken=${accessToken}&refreshToken=${refreshToken}`
            );
          }
        })
        .catch((_) => {
          window.getApp.showLoading(false);
          window.getApp.showMessage(
            'Truy cập thất bại, vui lòng thử lại',
            'error'
          );
        });
    },

    checkPhoneFromServer () {
      if (this.addUserForm.phone && validate.numeric(this.addUserForm.phone)) {
        this.checkPhone(this.addUserForm.phone)
          .then(result => {
            this.addUserForm.validateString.phone = '';
          })
          .catch(result => {
            this.addUserForm.validateString.phone =
              result.code === 'ERR_INVALID_PHONENUMBER'
                ? 'Số điện thoại không đúng định dạng'
                : result.code === 'ERR_PHONENUMBER_USED'
                  ? 'Số điện thoại đã được sử dụng'
                  : '';
          });
      }
    },

    checkEmailFromServer () {
      if (this.addUserForm.email && validate.numeric(this.addUserForm.email)) {
        this.checkEmail(this.addUserForm.email)
          .then(result => {
            this.addUserForm.validateString.email = '';
          })
          .catch(result => {
            this.addUserForm.validateString.email =
              result.code === 'ERR_EMAIL_NOT_EXIST'
                ? 'Email không tồn tại trong hệ thống'
                : result.code === 'ERR_EMAIL_USED'
                  ? 'Email đã được sử dụng'
                  : '';
          });
      }
    },

    createUserSubmit () {
      if (this.addUserForm.isValid) {
        this.addUserForm.isLoading = true;
        this.createUser(this.addUserForm)
          .then(res => {
            this.addUserForm.isLoading = false;
            this.addUserForm.isShowDialog = false;
            window.getApp.showMessage('Tạo người dùng thành công');
            setTimeout(() => {
              this.$emit('reload');
            }, 500);
          })
          .catch(_ => {
            this.addUserForm.isLoading = false;
            window.getApp.showMessage(
              'Đăng ký tài khoản thất bại, vui lòng thử lại',
              'error'
            );
          });
      } else {
        this.$refs.addUserForm.validate();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/account/components/user.vue